// 登录、重置密码、注册
import request from '@/utils/request';
import { encryptString } from '@/utils';

const serverUrl = process.env.VUE_APP_BASE_API;
// const paymentUrl = process.env.VUE_APP_PAYMENT_BASE_API;

const lounge = {
  // 获取机场过滤信息
  getFilterData(data) {
    return request({
      // url: `${serverUrl}/visa/latam/index/getFilter/v2`,
      url: `${serverUrl}/visa/latam/canada/web/getFilter`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 获取机场休息室列表和餐厅列表
  getCardList(data) {
    return request({
      // url: `${serverUrl}/visa/latam/index/resAndLouList`,
      url: `${serverUrl}/visa/latam/canada/web/explore`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 获取机场休息室列表和餐厅权益列表
  getLoungeList(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/list?type=${data.type}&lang=${data.lang}&userId=${data.userId}`,
      method: 'GET',
    });
  },
  getRetailList(data) {
    return request({
      url: `${serverUrl}/visa/latam/retail/findListByParams`,
      method: 'POST',
      data,
    });
  },

  // 获取benefits列表
  getBenefitsList(data) {
    const { userId, sessionId, ...params } = data;
    const formData = new FormData();
    if (userId) formData.append('userId', userId);
    if (sessionId) formData.append('sessionId', sessionId);

    return request({
      url: `${serverUrl}/visa/latam/web/benefit/home`,
      method: 'POST',
      params,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 获取休息室详情
  getLoungeDetails(data) {
    return request({
      url: `${serverUrl}/visa/latam/lounge/detail`,
      method: 'POST',
      data,
    });
  },
  // 获取休息室详情
  getLoungeDetailsV2(data) {
    return request({
      url: `${serverUrl}/visa/latam/lounge/detailV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  // 获取餐厅详情
  getDiningDetails(data) {
    return request({
      // url: `${serverUrl}/visa/latam/restaurant/detail`,
      url: `${serverUrl}/visa/latam/canada/web/v2/detail`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  // 获取零售店详情
  getRetailDetails(data) {
    return request({
      url: `${serverUrl}/visa/latam/retail/findDetail`,
      method: 'POST',
      data,
    });
  },
  // 获取offer/benefit详情
  getOfferBenefitDetails(data) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/getById`,
      method: 'POST',
      data,
    });
  },
  // 添加收藏休息室
  addFavorLounge(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/favorite/add`,
      method: 'POST',
      data,
    });
  },
  // 取消收藏休息室
  cancelFavorLounge(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/favorite/cancel`,
      method: 'POST',
      data,
    });
  },
  // 获取零售店的航站楼和入口信息
  getRetailTerminalAndGate(data) {
    return request({
      url: `${serverUrl}/visa/latam/retail/terminals`,
      method: 'GET',
      params: data,
    });
  },
  // 获取在航站楼和入口过滤下需要展示的零售店信息
  getRetailInfoByFilter(data) {
    return request({
      url: `${serverUrl}/visa/latam/retail/findRetailsByCodes`,
      method: 'POST',
      data,
    });
  },

  diningPDF(data) {
    return request({
      // url: `${serverUrl}/visa/latam/restaurant/getRestaurantPdf`,
      url: `${serverUrl}/visa/latam/canada/getRedeemPdf`,
      method: 'POST',
      responseType: 'blob',
      data,
      // headers: {
      //   'Content-Type': 'application/json',
      // },
    });
  },
  retailPDF(data) {
    return request({
      url: `${serverUrl}/visa/latam/retail/getRetailPdf`,
      method: 'POST',
      responseType: 'blob',
      data,
    });
  },
  customShowBanner(data) {
    return request({
      url: `${serverUrl}/visa/latam/trafficsite/customShowBanner`,
      method: 'POST',
      data,
    });
  },

  // 休息室获取预定可选日期
  getPrebookingDate(data) {
    return request({
      url: `${serverUrl}/visa/latam/lounge/getPrebookingDate`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 休息室获取预定可选日期
  getPrebookingTime(data) {
    return request({
      url: `${serverUrl}/visa/latam/lounge/getPrebookingTimeV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 休息室预定校验
  validationTime(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/validationV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 休息室价格
  getLoungePrice(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/infoV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 龙腾卡点数信息
  getDragonpassCardInfo(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/card-detail`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 信用卡信息
  getCreditCardInfo(data) {
    return request({
      url: `${serverUrl}/visa/latam/payment/ingenico/list`,
      method: 'POST',
      data,
    });
  },

  // 支付信息
  getPayDetail(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/pay-detailV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 支付校验
  async payInfoConfirm(data) {
    const { pw, ...rest } = data;
    const encryptedPw = pw ? await encryptString(pw) : null;
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/confirmationV2`,
      method: 'POST',
      data: {
        ...rest,
        pw: encryptedPw,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 预留休息室位置
  reserveLounge(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/reserveSpace`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 校验卡状态
  cardFreezeStatusCheck(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/cardFreezeStatusCheck`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default lounge;
